import AssocieFormController from './associe.form.controller';

export default {
    template: require('./associe.form.html'),
    controller: AssocieFormController
};
